<template>
  <el-form
    :model="active_data"
    ref="activeRef"
    label-width="180px"
    label-position="right"
    style="padding:20px 0 20px 0"
  >
    <!-- :rules="activeRules" -->
    <el-form-item label="店铺logo：" prop="img_logo" style="height:100px">
      <logo
        :wh="'height:100px;width:100px;background-color:#80c4ff;font-size:20px'"
        :tag="'logo'"
        :uploadWx="true"
        @getReturn="getReturn"
        @returnClose="returnClose"
      >
        LOGO
      </logo>
      <span style="display:inline-block;margin-left:110px">
        设置店铺logo
      </span>
    </el-form-item>
    <el-form-item
      label="活动名称："
      style="margin-top:40px"
      prop="activity_name"
    >
      <el-input
        v-model="active_data.activity_base_info.activity_name"
      ></el-input>
      <span style="display:inline-block;margin-left:20px">
        设置活动名称
      </span>
    </el-form-item>
    <el-form-item label="活动标题：" prop="activity_title">
      <el-input
        type="textarea"
        :rows="4"
        style="width:300px"
        v-model="active_data.activity_base_info.activity_second_title"
      ></el-input>
      <br />
      <span style="display:inline-block;margin-left:20px">
        设置该活动的活动标题。
      </span>
    </el-form-item>
    <el-form-item label="活动时间：" prop="begin_time">
      <el-col :span="5">
        <div id="date-div">
          <el-date-picker
            v-model="active_data.activity_base_info.begin_time"
            type="datetime"
            @change="getDate($event, 'begin_time')"
            placeholder="选择开始日期和时间"
          >
          </el-date-picker>
        </div>
      </el-col>
      <el-col :span="5">
        <div id="date-div">
          <el-date-picker
            v-model="active_data.activity_base_info.end_time"
            type="datetime"
            @change="getDate($event, 'end_time')"
            placeholder="选择截止日期和时间"
          >
          </el-date-picker>
        </div>
      </el-col>
    </el-form-item>

    <el-form-item
      label="消费门槛："
      style="margin-top:40px"
      prop="activity_name"
    >
      <el-input
        v-model="active_data.award_send_rule.transaction_amount_minimum"
      ></el-input>
      <span style="display:inline-block;margin-left:20px">
        注：到达该门槛，就发礼物（卷）
      </span>
    </el-form-item>
    <el-form-item
      label="选择活动卷："
      style="margin-top:40px"
      prop="activity_name"
    >
      <el-input
        v-model="active_data.award_send_rule.award_list[0].stock_id"
      ></el-input>
      <span style="display:inline-block;margin-left:20px">
        卷批次号
      </span>
    </el-form-item>

    <el-form-item label="活动宣传图：" style="height:180px" prop="img_activity">
      <logo
        :wh="
          'height:160px;width:160px;background-color:#80c4ff;font-size:20px;'
        "
        :tag="'thumbnail'"
        :uploadWx="true"
        @getReturn="getReturn"
        @returnClose="returnClose"
      >
        <div style="height:160px;width:288.9px'">
          奖品缩略图
        </div>
      </logo>
      <el-form-item label="活动宣传图：" style="height:180px">
        <logo
          :wh="
            'height:160px;width:288.9px;background-color:#80c4ff;font-size:20px;'
          "
          :tag="'bg'"
          :uploadWx="true"
          @getReturn="getReturn"
          @returnClose="returnClose"
        >
          <div style="height:160px;width:288.9px'">
            活动奖品图
          </div>
        </logo>
      </el-form-item>
    </el-form-item>
  </el-form>
</template>
<script>
import { GenerateDiscount, createActive } from "@/api/index";
import logo from "@/components/logo.vue";
export default {
  name: "activeForm",
  components: {
    logo
  },
  data() {
    return {
      begin_time: "",
      end_time: "",
      active_data: {
        activity_base_info: {
          activity_name: "", //活动名称
          activity_second_title: "", //活动副标题
          merchant_logo_url: "", //商户logo
          begin_time: "",
          end_time: "",
          out_request_no: "", //（格式：商户id+日期+流水号）
          delivery_purpose: "OFF_LINE_PAY", //目的
          mini_programs_appid: "wx4a6fe8a684850f09"
        },
        award_send_rule: {
          transaction_amount_minimum: 1, //消费门槛
          send_content: "SINGLE_COUPON", //发放内容
          award_type: "BUSIFAVOR", //奖品类型
          award_list: [
            {
              stock_id: "1283560000000003",
              original_image_url: "", //奖品大图
              thumbnail_url: "" //奖品缩略图
            }
          ],
          merchant_option: "MANUAL_INPUT_MERCHANT",
          merchant_id_list: ["1635710781"]
        }
      },
      activeRules: {
        activity_name: [
          { required: true, message: "请输活动名称", trigger: "blur" }
        ],
        begin_time: [
          { required: true, message: "请选择活动时间", trigger: "change" }
        ],
        activity_title: [
          { required: true, message: "请设置活动标题", trigger: "blur" }
        ],
        img_logo: [
          { required: true, message: "请设置店铺logo", trigger: "change" }
        ],
        img_activity: [
          { required: true, message: "请上传活动宣传图", trigger: "blur" }
        ]
      }
    };
  },
  computed: {},
  mounted() {},
  methods: {
    test(e){
      console.log("返回值",e);
      console.log("开始时间：",this.begin_time);
    },
    //上传图片返回
    getReturn(res) {
      switch (res.tag) {
        case "logo":
          this.active_data.activity_base_info.merchant_logo_url = res.imgsrc;
          break;
        case "thumbnail":
          this.active_data.award_send_rule.award_list[0].thumbnail_url =
            res.imgsrc;
          break;
        case "bg":
          this.active_data.award_send_rule.award_list[0].original_image_url =
            res.imgsrc;
          break;
      }
    },
    //删除图片返回
    returnClose(res) {
      switch (res.tag) {
        case "tag":
          this.active_data.img_logo = "";
          break;
        case "thumbnail":
          this.active_data.img_thumbnail = "";
          break;
        case "bg":
          this.active_data.img_activity = "";
          break;
      }
    },
    async createActive() {
      this.active_data.award_send_rule.transaction_amount_minimum = Number(this.active_data.award_send_rule.transaction_amount_minimum);
      var that = this;
      this.active_data.activity_base_info.out_request_no =
        "1601011649" + this.getDateStr() + this.RandomStr(9);
      const res = await createActive(that.active_data);
      console.log(res);
      if (res.data.return_code == "FAIL" && res.data.return_msg) {
        this.warnMessage(res.data.return_msg);
      } else if (res.data.result_code == "FAIL" && res.data.result_msg) {
        this.warnMessage(res.data.result_msg);
      } else if (
        res.data.result_code == "SUCCESS" &&
        res.data.return_code == "SUCCESS"
      ) {
        this.successMessage("活动创建成功");
      }
    },
    getDate(date, str) {
      //TODO: formatDate 函数 改变
      this.active_data.activity_base_info[str] = this.formatDate(date, true);
      console.log(this.formatDate(date, true))
      /* this.active_data[str] = date;
      this.dateFormat(date.valueOf()); */
    },
    getCode(len) {
      var code = "";
      var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
      for (var i = 0; i < len; i++) {
        //设置随机数范围,这设置为0 ~ 62
        var index = Math.floor(Math.random() * len);
        //字符串拼接 将每次随机的字符 进行拼接
        code += random[index];
      }
      return code;
    }
  }
};
</script>
<style scoped>
.el-form {
  color: #9d9fa5;
}
#date-div >>> .el-input {
  width: 200px !important;
}
.el-form-item >>> .el-input {
  width: 300px !important;
}
.el-divider--horizontal {
  height: 0.1px;
  margin-top: 5px !important;
  margin-right: 30px !important;
  margin-bottom: 0 !important;
}
</style>
